import React from 'react';
import './TermsPage.css';

const TermsPage: React.FC = () => {
  return (
    <div className="terms-page-container">
      <div className="terms-card-wrapper">
        <header className="terms-header">
          <h1 className="terms-title">Terms of Service</h1>
          <div className="terms-subtitle">Last updated: January 18, 2026</div>
          <div className="title-underline"></div>
        </header>

        <div className="terms-body">
          <section className="terms-intro-section">
            <p>Welcome to <strong>Colorfuel</strong>. By accessing or using this website and its related services (the "Service"), you agree to the following terms and conditions. Please read them carefully.</p>
          </section>

          <div className="terms-sections-container">
            <section className="terms-item">
              <div className="item-number">01</div>
              <div className="item-content">
                <h2>Acceptance of Terms</h2>
                <p>By using Colorfuel, you acknowledge that you have read, understood, and agreed to be bound by these Terms of Service. If you do not agree, please do not use the platform.</p>
              </div>
            </section>

            <section className="terms-item">
              <div className="item-number">02</div>
              <div className="item-content">
                <h2>Blockchain Networks</h2>
                <p>Colorfuel operates on decentralized networks, specifically Ethereum and Solana. By interacting with the Colorfuel platform, you understand and accept that all actions, including transactions, wallet interactions, or smart contract executions, occur on public blockchains and are <strong>irreversible</strong>.</p>
              </div>
            </section>

            <section className="terms-item">
              <div className="item-number">03</div>
              <div className="item-content">
                <h2>Use at Your Own Risk</h2>
                <p>All interactions with the Colorfuel platform are done entirely at your own risk. We provide the tools, but you are responsible for the outcome.</p>
                <ul className="terms-list">
                  <li>We do not control the underlying blockchain networks.</li>
                  <li>We do not guarantee the availability, security, or success of any transaction.</li>
                  <li>You are solely responsible for managing your wallet, private keys, and ensuring the correctness of all on-chain actions.</li>
                </ul>
              </div>
            </section>

            <section className="terms-item">
              <div className="item-number">04</div>
              <div className="item-content">
                <h2>No Liability for Transactions</h2>
                <p>Colorfuel assumes no responsibility or liability for any loss of funds, failed transactions, or unintended outcomes resulting from your use of the platform. All transactions are at your own risk.</p>
              </div>
            </section>

            <section className="terms-item">
              <div className="item-number">05</div>
              <div className="item-content">
                <h2>No Customer Support</h2>
                <p>Colorfuel does not provide any form of customer service or support at this time. Use the platform only if you are comfortable with a self-managed experience.</p>
              </div>
            </section>

            <section className="terms-item">
              <div className="item-number">06</div>
              <div className="item-content">
                <h2>No Warranties</h2>
                <p>Colorfuel is provided "as is" and "as available," without warranties of any kind, either express or implied. We make no representations about the accuracy or reliability of the platform.</p>
              </div>
            </section>

            <section className="terms-item">
              <div className="item-number">07</div>
              <div className="item-content">
                <h2>Changes to Terms</h2>
                <p>We reserve the right to modify or update these Terms at any time without notice. Continued use of the platform after changes are posted constitutes your acceptance of the new terms.</p>
              </div>
            </section>
          </div>

          <footer className="terms-page-footer">
            <div className="footer-warning">
              <p>If you have any concerns about using Colorfuel, we strongly recommend that you do not engage with the platform until you are confident in your understanding of blockchain technologies and their associated risks.</p>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
